// Vue & Plugins
import { App } from 'vue'

import { definePreset } from '@primeuix/themes'
import Nora from '@primeuix/themes/nora'
import Accordion from 'primevue/accordion'
import AccordionContent from 'primevue/accordioncontent'
import AccordionHeader from 'primevue/accordionheader'
import AccordionPanel from 'primevue/accordionpanel'
// Form
import AutoComplete from 'primevue/autocomplete'
// Misc
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
// Button
import Button from 'primevue/button'
import ButtonGroup from 'primevue/buttongroup'
import Calendar from 'primevue/calendar'
// Panel
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import ColorPicker from 'primevue/colorpicker'
// Data
import Column from 'primevue/column'
// PrimeVue
import PrimeVue from 'primevue/config'
// Services
import ConfirmationService from 'primevue/confirmationservice'
// Overlay
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmPopup from 'primevue/confirmpopup'
// Menu
import ContextMenu from 'primevue/contextmenu'
import DataTable from 'primevue/datatable'
import DatePicker from 'primevue/datepicker'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'
import Drawer from 'primevue/drawer'
import Fieldset from 'primevue/fieldset'
// File
import FileUpload from 'primevue/fileupload'
import FloatLabel from 'primevue/floatlabel'
import IconField from 'primevue/iconfield'
// Media
import Image from 'primevue/image'
import ImageCompare from 'primevue/imagecompare'
import InlineMessage from 'primevue/inlinemessage'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputIcon from 'primevue/inputicon'
import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import Listbox from 'primevue/listbox'
import Menu from 'primevue/menu'
import MenuBar from 'primevue/menubar'
// Message
import Message from 'primevue/message'
import MeterGroup from 'primevue/metergroup'
import MultiSelect from 'primevue/multiselect'
import OverlayBadge from 'primevue/overlaybadge'
import OverlayPanel from 'primevue/overlaypanel'
import Paginator from 'primevue/paginator'
import Panel from 'primevue/panel'
import Password from 'primevue/password'
import PickList from 'primevue/picklist'
import Popover from 'primevue/popover'
import ProgressBar from 'primevue/progressbar'
import ProgressSpinner from 'primevue/progressspinner'
import RadioButton from 'primevue/radiobutton'
import ScrollPanel from 'primevue/scrollpanel'
import Select from 'primevue/select'
import SelectButton from 'primevue/selectbutton'
import Skeleton from 'primevue/skeleton'
import Slider from 'primevue/slider'
import SplitButton from 'primevue/splitbutton'
import Step from 'primevue/step'
import StepList from 'primevue/steplist'
import StepPanel from 'primevue/steppanel'
import StepPanels from 'primevue/steppanels'
import Stepper from 'primevue/stepper'
import Tab from 'primevue/tab'
import TabList from 'primevue/tablist'
import TabPanel from 'primevue/tabpanel'
import TabPanels from 'primevue/tabpanels'
import Tabs from 'primevue/tabs'
import Tag from 'primevue/tag'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import ToggleButton from 'primevue/togglebutton'
import ToggleSwitch from 'primevue/toggleswitch'
import Toolbar from 'primevue/toolbar'
import Tooltip from 'primevue/tooltip'
import VirtualScroller from 'primevue/virtualscroller'

export const csPresetNora = definePreset(Nora, {
  primitive: {
    orange: {
      50: 'var(--color-orange-50)',
      100: 'var(--color-orange-100)',
      200: 'var(--color-orange-200)',
      300: 'var(--color-orange-300)',
      400: 'var(--color-orange-400)',
      500: 'var(--color-orange-500)',
      600: 'var(--color-orange-700)', // Fix an issue with text colour contrast on multiple components
      700: 'var(--color-orange-700)',
      800: 'var(--color-orange-800)',
      900: 'var(--color-orange-900)',
      950: 'var(--color-orange-950)',
    },

    yellow: {
      50: 'var(--color-yellow-50)',
      100: 'var(--color-yellow-100)',
      200: 'var(--color-yellow-200)',
      300: 'var(--color-yellow-300)',
      400: 'var(--color-yellow-400)',
      500: 'var(--color-yellow-500)',
      600: 'var(--color-yellow-700)', // Fix an issue with text colour contrast on multiple components
      700: 'var(--color-yellow-700)',
      800: 'var(--color-yellow-800)',
      900: 'var(--color-yellow-900)',
      950: 'var(--color-yellow-950)',
    },

    green: {
      50: 'var(--color-green-50)',
      100: 'var(--color-green-100)',
      200: 'var(--color-green-200)',
      300: 'var(--color-green-300)',
      400: 'var(--color-green-400)',
      500: 'var(--color-green-500)',
      600: 'var(--color-green-600)', // Fix an issue with text colour contrast on multiple components
      700: 'var(--color-green-700)',
      800: 'var(--color-green-800)',
      900: 'var(--color-green-900)',
      950: 'var(--color-green-950)',
    },

    sky: {
      50: 'var(--color-sky-50)',
      100: 'var(--color-sky-100)',
      200: 'var(--color-sky-200)',
      300: 'var(--color-sky-300)',
      400: 'var(--color-sky-400)',
      500: 'var(--color-sky-500)',
      600: 'var(--color-sky-700)', // Fix an issue with text colour contrast on multiple components
      700: 'var(--color-sky-700)',
      800: 'var(--color-sky-800)',
      900: 'var(--color-sky-900)',
      950: 'var(--color-sky-950)',
    },

    blue: {
      50: 'var(--color-blue-50)',
      100: 'var(--color-blue-100)',
      200: 'var(--color-blue-200)',
      300: 'var(--color-blue-300)',
      400: 'var(--color-blue-400)',
      500: 'var(--color-blue-500)',
      600: 'var(--color-blue-600)',
      700: 'var(--color-blue-700)',
      800: 'var(--color-blue-800)',
      900: 'var(--color-blue-900)',
      950: 'var(--color-blue-950)',
    },

    zinc: {
      50: 'var(--color-zinc-50)',
      100: 'var(--color-zinc-100)',
      200: 'var(--color-zinc-200)',
      300: 'var(--color-zinc-300)',
      400: 'var(--color-zinc-400)',
      500: 'var(--color-blue-500)',
      600: 'var(--color-zinc-600)',
      700: 'var(--color-zinc-700)',
      800: 'var(--color-zinc-800)',
      900: 'var(--color-zinc-900)',
      950: 'var(--color-zinc-950)',
    },
  },

  semantic: {
    primary: {
      50: '#F4F8FB',
      100: '#E8EFF6',
      200: '#CDDDEA',
      300: '#A0C1D9',
      400: '#6DA0C3',
      500: '#4B84AC',
      600: '#396A90',
      700: '#2F5575',
      800: '#2A4962',
      900: '#273E53',
      950: '#1D2D3D',
    },
  },
})

export const registerPrimeVue = (app: App) => {
  app.use(PrimeVue, {
    theme: {
      preset: csPresetNora,
      options: {
        cssLayer: {
          name: 'primevue',
          order: 'theme, base, primevue',
        },
        darkModeSelector: '.dark',
      },
    },
  })

  // Form
  app.component('AutoComplete', AutoComplete)
  app.component('Calendar', Calendar)
  app.component('DatePicker', DatePicker)
  app.component('Checkbox', Checkbox)
  app.component('ColorPicker', ColorPicker)
  app.component('Select', Select)
  app.component('InputText', InputText)
  app.component('InputGroup', InputGroup)
  app.component('InputGroupAddon', InputGroupAddon)
  app.component('InputNumber', InputNumber)
  app.component('InputSwitch', InputSwitch)
  app.component('MultiSelect', MultiSelect)
  app.component('SelectButton', SelectButton)
  app.component('Textarea', Textarea)
  app.component('Listbox', Listbox)
  app.component('ToggleButton', ToggleButton)
  app.component('InputIcon', InputIcon)
  app.component('IconField', IconField)
  app.component('FloatLabel', FloatLabel)
  app.component('ToggleSwitch', ToggleSwitch)
  app.component('Slider', Slider)
  app.component('InputMask', InputMask)
  app.component('Password', Password)
  app.component('RadioButton', RadioButton)

  // Button
  app.component('Button', Button)
  app.component('ButtonGroup', ButtonGroup)
  app.component('SplitButton', SplitButton)

  // Data
  app.component('DataTable', DataTable)
  app.component('Column', Column)
  app.component('PickList', PickList)
  app.component('VirtualScroller', VirtualScroller)
  app.component('Paginator', Paginator)

  // Panel
  app.component('Card', Card)
  app.component('Divider', Divider)
  app.component('Panel', Panel)
  app.component('Accordion', Accordion)
  app.component('AccordionPanel', AccordionPanel)
  app.component('AccordionContent', AccordionContent)
  app.component('AccordionHeader', AccordionHeader)
  app.component('Fieldset', Fieldset)
  app.component('Stepper', Stepper)
  app.component('Step', Step)
  app.component('StepList', StepList)
  app.component('StepPanel', StepPanel)
  app.component('StepPanels', StepPanels)
  app.component('ScrollPanel', ScrollPanel)
  app.component('Tab', Tab)
  app.component('Tabs', Tabs)
  app.component('TabPanel', TabPanel)
  app.component('TabPanels', TabPanels)
  app.component('TabList', TabList)

  // Overlay
  app.component('ConfirmDialog', ConfirmDialog)
  app.component('ConfirmPopup', ConfirmPopup)
  app.component('OverlayPanel', OverlayPanel)
  app.directive('tooltip', Tooltip)
  app.component('Popover', Popover)
  app.component('Drawer', Drawer)
  app.component('Dialog', Dialog)

  // File
  app.component('FileUpload', FileUpload)

  // Menu
  app.component('Menu', Menu)
  app.component('ContextMenu', ContextMenu)
  app.component('MenuBar', MenuBar)
  app.component('Toolbar', Toolbar)

  // Message
  app.component('Message', Message)
  app.component('InlineMessage', InlineMessage)

  // Media
  app.component('Image', Image)
  app.component('ImageCompare', ImageCompare)

  // Misc
  app.component('Avatar', Avatar)
  app.component('Badge', Badge)
  app.component('Chip', Chip)
  app.component('ProgressSpinner', ProgressSpinner)
  app.component('ProgressBar', ProgressBar)
  app.component('Tag', Tag)
  app.component('OverlayBadge', OverlayBadge)
  app.component('Skeleton', Skeleton)
  app.component('MeterGroup', MeterGroup)

  // Services
  app.component('Toast', Toast)
  app.use(ConfirmationService)
  app.use(ToastService)
}
